import { render } from "./MenuItemIcon.vue?vue&type=template&id=5dd51116&scoped=true"
import script from "./MenuItemIcon.vue?vue&type=script&lang=js"
export * from "./MenuItemIcon.vue?vue&type=script&lang=js"

import "./MenuItemIcon.vue?vue&type=style&index=0&id=5dd51116&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5dd51116"]])

export default __exports__